import React, {useState, useEffect, useMemo} from 'react';
import {ignoreTextFieldKeys, getRegexpDescription} from "ultra/helpers/utils";

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import {useFormStore} from '../../../Stores/form';

export default function Text(props) {
    const {content, disabled, field, sufix, prefix, className, isEditMode, onChange, onBlur, onFocus, inputMode, hideErrors} = props;
    // fieldErrorCheck
    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => { setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [InputProps, setInputProps] = useState({});

    const [regexpHighlight, setRegexpHighlight] = useState(false)

    const formatedRegexp = useMemo(() => {
        if (!field?.options?.regexp) return "";        
        return "Доступні для вводу символи: " + getRegexpDescription(field.options.regexp);
    }, [field?.options?.regexp])

    useEffect(() => {
        const p = field?.options?.prefix || prefix
        const s = field?.options?.sufix || sufix

        const params = {}
        if (p) params.startAdornment = <InputAdornment position="start">{p}</InputAdornment>
        if (s) params.endAdornment = <InputAdornment position="start">{s}</InputAdornment>
        setInputProps(params)
    }, [prefix, sufix, field])

    const onBlurHandler = (e) => {
        if (onBlur) onBlur(e);
        setRegexpHighlight(false);

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    const onPasteHandler = (e) => {
        if (field?.options?.regexp) {
            const regex = new RegExp(field.options.regexp);
            const pastedData = (e.clipboardData || window.clipboardData).getData('text');
            if (!regex.test(pastedData)) {
                setRegexpHighlight(true);
                e.preventDefault();
            }
        }

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    const onKeyDownHandler = (e) => {
        if (!field?.options?.regexp) return false;
        const regex = new RegExp(field.options.regexp);

        if (((e.ctrlKey || e.metaKey) && e.key === 'v') || e.key === 'Enter') {
            if (!ignoreTextFieldKeys(e) && !regex.test(e?.target?.value)) {
                setRegexpHighlight(true);
            }
            else {
                setRegexpHighlight(false);
            }

            return false;
        }

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight(true);
        }
        else {
            setRegexpHighlight(false);
        }

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    return (<Grid key={field?.id} item xs={12}>
        <TextField
            error={regexpHighlight || Boolean(!regexpHighlight && !hideErrors && showErrorText)}
            helperText={!regexpHighlight && !hideErrors && showErrorText}
            fullWidth
            className={className}
            value={content[field.id] || ''}
            required={field?.required}
            label={field?.placeholder}
            variant="outlined"
            onKeyDown={onKeyDownHandler}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlurHandler}
            onPaste={onPasteHandler}
            disabled={isDisabled}
            inputProps={{
                maxLength: field?.options?.maxLength,
                inputMode: inputMode,
            }}
            InputProps={InputProps}
        />
        {!showErrorText && !regexpHighlight && (field?.notes || field?.options?.maxLength) && <div className="fieldNotes">
            {field?.options?.maxLength && <p>* максимальна кількість символів - {field?.options?.maxLength}</p>}
            {field?.notes && <p>{field.notes}</p>}
        </div>}

        {regexpHighlight && field?.options?.regexp && <div className={regexpHighlight ? "fieldNotes fieldNotesRegexpError" : "fieldNotes"}>
            <p>{formatedRegexp}</p>
        </div>}
    </Grid>)
}
